export const TiposEnum = [
    { id: "mensal", label: "Mensal" },
    { id: "anual", label: "Anual" },
    { id: "trimestral", label: "Trimestral" },

];

export const SetoresEnum = [
    { id: "contabilidade", label: "Contabilidade" },
    { id: "legalizacaoOnboarding", label: "Lergalização & Onborging" },
    { id: "cs", label: "CS" },
];

export const ContabilidadeSubSetoresEnum = [
    { id: "contabilidade", label: "Contabilidade" },
    { id: "fiscal", label: "Fiscal" },
    { id: "departamento_pessoal", label: "Departamento Pessoal" },
];


export const LegalizacaoSubSetoresEnum = [
    { id: "alvaras e taxas", label: "Alvarás e taxas" },
];

export const CsSubSetoresEnum = [
    { id: "credenciamento", label: "Credenciamento" },
    { id: "nota fiscal", label: "Nota Fiscal" },
];


export const TipoTaxasEnum = [
    {
        label: "Selecione uma taxa",
        value: 0,
    },
    {
        label: "Taxa de Alvará",
        value: 1,
    },
    {
        label: "Taxa de Fiscalização",
        value: 2,
    },
    {
        label: "Taxa de Expediente",
        value: 3,
    },
    {
        label: "Taxa Mobiliaria",
        value: 4,
    },
    {
        label: "Taxa de Fiscalização de Funcionamento",
        value: 5,
    },
    {
        label: "Taxa de Licença e Localização de Estabelecimento",
        value: 6,
    },
    {
        label: "Taxa de Vigilância Sanitária",
        value: 7,
    },
    {
        label: "Taxa de Emolumento",
        value: 8,
    },
    {
        label: "Taxa de Acesso de Notas",
        value: 9,
    },
    {
        label: "Taxa de Parecer Técnico",
        value: 10,
    },
    {
        label: "Taxa de Bombeiros",
        value: 11,
    },
    {
        label: "Taxa de Viabilidade",
        value: 12,
    },
    {
        label: "Taxa de Meio Ambiente",
        value: 13,
    }
];

